// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"224":"register","962":"home"}[chunkId] + "." + {"224":"b4a78520","962":"336106c5"}[chunkId] + ".css";
};